import { Content } from "pdfmake/interfaces";
import getLegendTable, { LineLegendRow } from "./legend-table";

const MAX_TABLE_COUNT = 3;
const SINGLE_TABLE_MAX_ROWS = 6;
const MAX_LEGEND_ROWS = MAX_TABLE_COUNT * SINGLE_TABLE_MAX_ROWS;

const getLegendLayout = (rows: LineLegendRow[]): Content => {
  const limitedRows = rows.slice(0, MAX_LEGEND_ROWS);

  const tableRows: LineLegendRow[][] = [];
  for (let i = 0; i < limitedRows.length; i += SINGLE_TABLE_MAX_ROWS) {
    tableRows.push(limitedRows.slice(i, i + SINGLE_TABLE_MAX_ROWS));
  }

  const tableColumns: any[] = [];
  tableRows.forEach((table, index) => {
    tableColumns.push({ width: "auto", stack: [getLegendTable(table)] });
    if (index < tableRows.length - 1) {
      tableColumns.push({ width: 24, text: "" });
    }
  });

  return {
    columns: [
      { width: "*", text: "" },
      ...tableColumns,
      { width: "*", text: "" }
    ],
    columnGap: 0
  };
};

export default getLegendLayout;
